<script>
import { mapGetters } from "vuex";
import moment from "moment";

import { api } from "@/store/modules/audit";
import { api as apiStandards } from "@/store/modules/standards";

const scoreToComplianceScore = score => {
  const total_range = score.best - score.worst;
  const current_range = score.current - score.worst;
  const compliance = Math.round((current_range / total_range) * 100);
  return compliance;
};

export default {
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.getAuditReportSummary,
      api.getters.getScoreCalcSteps
    ]),
    ...mapGetters(apiStandards.namespace, [
      apiStandards.getters.loadedStandards
    ]),
    currentCalcScore() {
      const calc_score = this.getScoreCalcSteps;
      console.log("getScoreCalcSteps", calc_score);
      return calc_score;
    },

    currentAuditReportSummary() {
      return this.getAuditReportSummary;
    },
    complianceScore() {
      return scoreToComplianceScore(
        this.currentAuditReportSummary.score.inTotal
      );
    },
    currentAuditSummary() {
      const audit_summary = this.currentAuditReportSummary;
      const calc_score = this.currentCalcScore;
      console.log("Audit-Summary", audit_summary, calc_score);

      const metadata = [
        {
          field: "standard",
          description: "Auditierter Standard",
          value: this.auditStandard
        },
        {
          field: "type",
          description: "Audit Art",
          value: audit_summary.auditType
        },
        {
          field: "audited_by",
          description: "Audit Typ ",
          value: audit_summary.auditedBy
        },
        /*{
          field: "scope",
          description: "Auditierter Bereich",
          value: audit_summary.scope
        },*/
        {
          field: "leadauditor",
          description: "Lead-Auditor",
          value: audit_summary.leadAuditor
            ? audit_summary.leadAuditor.displayName
            : " - "
        },
        // {
        //   field: "planning_date",
        //   description: "Auditplanungs-Termin",
        //   value: audit_summary.auditPlaningDate
        // },
        {
          field: "auditing_date",
          description: "Auditdurchführungs-Termin",
          value: this.auditingDates
        },
        {
          field: "analysis-1",
          description: "Anzahl Audit-Kriterien (Fragen)",
          value: calc_score.criteriaTotalCount
        },
        {
          field: "analysis-2",
          description: "Anzahl Feststellungen",
          value: calc_score.deviationsTotalCount
        },
        {
          field: "analysis-3",
          description: "Anzahl Maßnahmen",
          value: audit_summary.statistics.auditMeasuresCount
        },
        {
          field: "score-best",
          description: "Best Possible Score",
          value: calc_score.bestScore
        },
        {
          field: "score-worst",
          description: "Worst Possible Score",
          value: calc_score.worstScore
        },
        {
          field: "score-not-applicabel",
          description: "Score (Nicht Zutreffend)",
          value: calc_score.criteriaNotApplicabelTotalScore
        },
        {
          field: "score-current",
          description: "Current Score",
          value: calc_score.currentScore
        },
        {
          field: "score-percent",
          description: "Audit Score [%]",
          value: (calc_score.compliancePercent * 100).toFixed(2) // scoreToComplianceScore(audit_summary.score.inTotal)
        }
      ];

      return metadata;
    },
    auditStandard() {
      const standard_ids =
        this.currentAuditReportSummary.auditStandard instanceof Array
          ? this.currentAuditReportSummary.auditStandard
          : [this.currentAuditReportSummary.auditStandard];
      const loaded_standards = this.loadedStandards;

      return standard_ids
        .map(standard_id => {
          return loaded_standards[standard_id]
            ? loaded_standards[standard_id].name
            : null;
        })
        .filter(v => v !== null);
    },
    auditingDates() {
      return this.currentAuditReportSummary.auditingDates
        .map(date => moment(date).format("L"))
        .join(", ");
    }
  }
};
</script>
